import type { PsdSeries } from '../../types';

const LF_MIN_HZ = 0.04;
const LF_MAX_HZ = 0.15;
const HF_MIN_HZ = 0.15;
const HF_MAX_HZ = 0.4;

export const integrateBandPower = (
  frequencies: number[],
  psd: number[],
  minHz: number,
  maxHz: number
) => {
  if (frequencies.length <= 1) return 0;
  const deltaF = frequencies[1] - frequencies[0];
  let power = 0;
  for (let index = 0; index < frequencies.length; index += 1) {
    const frequency = frequencies[index];
    if (frequency >= minHz && frequency < maxHz) {
      power += psd[index] * deltaF;
    }
  }
  return power;
};

export const computeLfHfRatioFromPsd = (psd: PsdSeries): number | null => {
  if (psd.frequencies.length === 0) return null;

  const values = psd.psd_lf;
  const powerLf = integrateBandPower(
    psd.frequencies,
    values,
    LF_MIN_HZ,
    LF_MAX_HZ
  );
  const powerHf = integrateBandPower(
    psd.frequencies,
    values,
    HF_MIN_HZ,
    HF_MAX_HZ
  );

  if (powerHf <= 0) return null;
  return powerLf / powerHf;
};
